var AddEditUserPageController = /** @class */ (function () {
    /*@ngInject*/
    function AddEditUserPageController($scope, $rootScope, $state, $timeout, $filter, $uibModal, $transitions, StorageService, utilityService, userRoleService, employeeService, userService, companyService, USERMANAGEMENTCONSTANTS, MESSAGECONSTANTS, alertsAndNotificationsService, uibModalService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.$transitions = $transitions;
        this.StorageService = StorageService;
        this.utilityService = utilityService;
        this.userRoleService = userRoleService;
        this.employeeService = employeeService;
        this.userService = userService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.USERMANAGEMENTCONSTANTS = USERMANAGEMENTCONSTANTS;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
    }
    AddEditUserPageController.prototype.$onInit = function () {
        var _this = this;
        this.$stateParams = this.$transition$.params();
        this.form = {};
        this.userProfile = {};
        this.userProfileReset = {};
        this.userProfile.userDetails = {};
        this.userProfile.userScopeDetails = {};
        this.userProfile.userForwardRecipientDetails = {};
        this.companyType = this.$rootScope.userDetails.company.companyType;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = (this.$rootScope.userDetails.company.companyType == 'Corporation');
        this.forwardRecipients = [];
        this.geoLocations = [];
        this.geoLocationsCopy = [];
        this.lastStep = false;
        this.profilePic = '';
        this.roleChanged = false;
        this.oldRole = null;
        this.managerChanged = false;
        this.oldManager = null;
        this.userCreated = false;
        this.roles = [];
        this.buList = [];
        this.clientsOrBUList = [];
        this.selectedDepartmentObjectsArray = [];
        this.switchClicked = false;
        this.showConfirmationPopup = false;
        this.copyCompanyAddress = false;
        this.zipCodeCalling = false;
        this.zipCodeCallCompleted = false;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.isUserBelongsToBUChanged = false;
        this.editProfileEnabled = false;
        this.isLoading = true;
        this.formSubmitted = false;
        this.valid = false;
        this.triggerCount = 0;
        this.updatedManager = null;
        this.telephoneNumberFormat = '+1 201-555-0123';
        this.mobileNumberFormat = '+1 201-555-0123';
        this.countryCodeForTelephone = 'us';
        this.countryCodeForTelephone = 'us';
        this.fromUserProfile = angular.copy(this.$stateParams.purpose);
        this.isValidWorkTelephoneEntered = false;
        this.isValidMobileNumberEntered = false;
        this.mobileNumberDirty = false;
        this.workTelephoneDirty = false;
        this.canAddUserAtCompanyLevel = false;
        this.canAddUserAtDepartmentOrBULevel = false;
        this.nextButtonFlag = 0;
        this.saveButtonFlag = 0;
        this.recentButtonClick = 'nextButton';
        this.dateTimeCount = 0;
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        this.cancelClicked = false;
        this.isCountyExists = false;
        this.isInHost = this.utilityService.isInHost();
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.isCorporateCompany = this.companyService.isCorporateCompany();
        this.accessMode = angular.copy(this.$stateParams.accessMode);
        this.managerDetails = angular.copy(this.$stateParams.manager);
        this._handleBrowserEvents();
        if (this._isCreateUserUnderManager()) {
            this.isLoading = false;
            if (!angular.equals(this.managerDetails, null) && !angular.equals(this.managerDetails.lastName, null)) {
                this.managerDetails.firstName = this.managerDetails.firstName + ' ' + this.managerDetails.lastName;
            }
            this.StorageService.set('useraccessmode', this.accessMode);
            this.StorageService.remove('userProfile');
            this.StorageService.set('manager', this.managerDetails);
            this.userProfile.departmentId = null;
            this.userProfile.deparmentName = null;
            this.userProfile.buId = null;
            this.userProfile.buName = null;
            this.userProfile.isPointOfContact = false;
            this.userProfileReset = angular.copy(this.userProfile);
            this.userService.getUserRoleEntityScopeById(this.managerDetails.userId, this.companyId, this.managerDetails.roleId, function (data) {
                _this.clientOrBUList = data.clientOrBUList;
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                console.log('error');
            });
            this._getUserBelongsTo();
            this._getRolesInTheCompany();
            this._setDepartment();
            this._createWizard();
            this._setPhoneNumberFields();
        }
        else if (this._isEditOrViewUser()) {
            this._getUserProfileInfo(function () {
                _this.isLoading = false;
                //view or update user access
                //Setting the Phone number values to be true
                _this.isValidMobileNumberEntered = true;
                _this.isValidWorkTelephoneEntered = true;
                _this.$timeout(function () {
                    _this._getAddressDetails(angular.copy(_this.userObject.userDetails.zipcode), 'start', function (response) {
                        _this.geoLocationsCopy = angular.copy(_this.geoLocations);
                    });
                }, 500);
                _this.StorageService.set('useraccessmode', _this.accessMode);
                _this.StorageService.remove('manager');
                _this.StorageService.set('userProfile', angular.copy(_this.userObject));
                _this.userProfile = angular.copy(_this.userObject);
                if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
                    // this.isLoading = false;
                    //access mode view
                    _this.$timeout(function () {
                        angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                    }, 200);
                    if (!angular.equals(_this.userProfile.userForwardRecipientDetails, null)) {
                        if (!angular.equals(_this.userProfile.userForwardRecipientDetails.forwardRecipient, null)) {
                            if (angular.isDefined(_this.userProfile.userForwardRecipientDetails.forwardRecipient.userId)) {
                                _this.userProfile.userForwardRecipientDetails.forwardRecipient.ticked = true;
                                if (_this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName != null) {
                                    var output = _this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName + " " + _this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName;
                                }
                                else {
                                    var output = _this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName;
                                }
                                if (output.length > 57) {
                                    _this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output.substring(0, 57) + "...";
                                }
                                else {
                                    _this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output;
                                }
                                _this.forwardRecipients.push(_this.userProfile.userForwardRecipientDetails.forwardRecipient);
                            }
                        }
                    }
                    _this.originalManagerObj = angular.copy(_this.userProfile.userDetails.manager);
                    if (!angular.equals(_this.originalManagerObj, null) && !angular.equals(_this.originalManagerObj.lastName, null)) {
                        _this.originalManagerObj.firstName = _this.originalManagerObj.firstName.split(" ")[0];
                    }
                }
                else if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    //access mode edit
                    angular.element('#email').attr({ 'readonly': true, 'disabled': true });
                    if ((_this.userProfile.userDetails.userId === _this.$rootScope.userDetails.id)) {
                        angular.element('#role').attr({ 'readonly': true, 'disabled': true });
                        _this.editProfileEnabled = true;
                    }
                    if (_this.isCompanyAdmin(_this.userProfile.userDetails.role)) {
                        angular.element('#manager').attr({ 'readonly': true, 'disabled': true });
                    }
                    _this.originalManagerObj = angular.copy(_this.userProfile.userDetails.manager);
                    if (!angular.equals(_this.originalManagerObj, null) && !angular.equals(_this.originalManagerObj.lastName, null)) {
                        _this.originalManagerObj.firstName = _this.originalManagerObj.firstName.split(" ")[0];
                    }
                    _this._populateForwardRecipient();
                }
                _this.userProfileReset = angular.copy(_this.userProfile);
                _this.userService.getUserRoleEntityScopeById(_this.userProfile.userDetails.userId, _this.companyId, _this.userProfile.userDetails.role.id, function (data) {
                    _this.clientOrBUList = data.clientOrBUList;
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    console.log('error');
                });
                _this._getUserBelongsTo();
                _this._getRolesInTheCompany();
                _this._setDepartment();
                _this._createWizard();
                _this._setPhoneNumberFields();
            });
        }
        else {
            // when refresh
            var useraccessmode = this.StorageService.get('useraccessmode');
            var userProfile = this.StorageService.get('userProfile');
            var manager = this.StorageService.get('manager');
            if ((manager !== null) && (useraccessmode !== null) && (userProfile === null)) {
                // create mode
                this.managerDetails = manager;
                this.accessMode = useraccessmode;
                this.userProfileReset = angular.copy(this.userProfile);
            }
            else if ((userProfile !== null) && (useraccessmode !== null) && (manager === null)) {
                //update or view mode
                this.userProfile = userProfile;
                this.accessMode = useraccessmode;
                this.StorageService.remove('manager');
                if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
                    angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                }
                else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    //access mode edit
                }
                this.userProfileReset = angular.copy(this.userProfile);
            }
            else {
                // if objects are not there both in storage and stateparams
                console.log('objects are not there both in storage and stateparams');
            }
            this._getRolesInTheCompany();
            this._setDepartment();
            this._createWizard();
            this._setPhoneNumberFields();
        }
        this.$timeout(function () {
            // this.form.userDetailsForm.$setPristine();
            if (document.getElementById('workTelephone') && document.getElementById('workTelephone').value.length > 0) {
                _this.workTelephoneDirty = true;
            }
            if (document.getElementById('mobileNumber') && document.getElementById('mobileNumber').value.length > 0) {
                _this.mobileNumberDirty = true;
            }
        }, 1500);
        // determine if add user option is allowed for this user
        if (this.userRoleService.isLoggedInUserAnAdmin()) {
            // admin user, add user is allowed in all cases
            this.canAddUserAtCompanyLevel = true;
            this.canAddUserAtDepartmentOrBULevel = true;
        }
        else {
            // if it is corporation, check bu permissibility
            if (this.isCorporateFlag) {
                // for non admin user
            }
            else {
                // for staffing, as of now employees can be added at all levels by all users
                this.canAddUserAtCompanyLevel = true;
                this.canAddUserAtDepartmentOrBULevel = true;
            }
        }
    };
    AddEditUserPageController.prototype._setPhoneNumberFields = function () {
        var _this = this;
        $(document).ready(function () {
            _this.$timeout(function () {
                $("#workTelephone").on("countrychange", function (e, countryData) {
                    _this.countryCodeForTelephone = countryData.iso2;
                    _this.form.userDetailsForm.workTelephone.$setDirty();
                    if (_this.countryCodeForTelephone !== undefined) {
                        _this._setWorkTelephoneCountryCode();
                    }
                });
                $("#mobileNumber").on("countrychange", function (e, countryData) {
                    _this.countryCodeForTelephone = countryData.iso2;
                    _this.form.userDetailsForm.mobileNumber.$setDirty();
                    if (_this.countryCodeForTelephone !== undefined) {
                        _this._setMobileNumberCountryCode();
                    }
                });
                $("#workTelephone").keyup(function () {
                    if (document.getElementById('workTelephone').value.length > 0) {
                        _this.workTelephoneDirty = true;
                    }
                    else {
                        _this.workTelephoneDirty = false;
                    }
                });
                $("#mobileNumber").keyup(function () {
                    if (document.getElementById('mobileNumber').value.length > 0) {
                        _this.mobileNumberDirty = true;
                    }
                    else {
                        _this.mobileNumberDirty = false;
                    }
                });
            }, 2000);
        });
    };
    AddEditUserPageController.prototype._isCreateUserUnderManager = function () {
        return this.$stateParams.manager !== null && this.$stateParams.accessMode === 'create';
    };
    AddEditUserPageController.prototype._isEditOrViewUser = function () {
        return this.$stateParams.accessMode !== 'create' && this.$stateParams.manager === null;
    };
    AddEditUserPageController.prototype._getUserBelongsTo = function () {
        var _this = this;
        var managerUserId = '';
        var userId = '';
        var isManager = true;
        if (this._isCreateUserUnderManager()) {
            managerUserId = this.managerDetails.userId;
        }
        else if (this.originalManagerObj) {
            managerUserId = this.originalManagerObj.userId;
            userId = this.userProfile.userDetails.userId;
        }
        else {
            userId = this.userProfile.userDetails.userId;
        }
        if (managerUserId === this.$rootScope.userDetails.id) {
            managerUserId = '';
        }
        this.userService.getUserBelongsTo(this.companyId, managerUserId, userId, function (data) {
            _this.buList = data.buInfos;
            if (data.belongsToCorp) {
                _this.canAddUserAtCompanyLevel = true;
                _this.canAddUserAtDepartmentOrBULevel = true;
            }
            else {
                _this.canAddUserAtCompanyLevel = false;
                _this.canAddUserAtDepartmentOrBULevel = true;
            }
            _this._setBuName();
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            console.log('error');
        });
    };
    AddEditUserPageController.prototype._setBuName = function () {
        var _this = this;
        var bu = _.filter(this.buList, function (bu) {
            return _this.userProfile.buId === bu.id;
        });
        //if the exising bu is not present in the bulist got for logged in user
        if (this.userProfile.buId !== null && this.userProfile.buId !== "" && bu.length == 0) {
            var buObject = { id: this.userProfile.buId, name: this.userProfile.buName };
            this.buList.push(buObject);
            bu.push(buObject);
        }
        if (bu.length > 0) {
            this.selectedBuName = bu[0].name;
        }
        else {
            this.selectedBuName = 'Corporate';
        }
    };
    AddEditUserPageController.prototype._getRolesInTheCompany = function () {
        var _this = this;
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
            var managerId = this.managerDetails.roleId;
        }
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
            this.userService.getUserCreateRoles(managerId, this.$rootScope.userDetails.company.companyType, function (data) {
                _this.roles = data;
                if (_this.isInHost) {
                    for (var i = 0; i < _this.roles.length; i++) {
                        if (_this.roles[i].name === _this.MESSAGECONSTANTS.ROLES.FOURDOTFIVEADMIN) {
                            _this.userProfile.userDetails.role = _this.roles[i];
                            _this.userProfileReset.userDetails.role = _this.roles[i];
                        }
                    }
                }
                else if (_this.isStaffingCompany || _this.isCorporateCompany) {
                    if (_this.roles.length === 1) {
                        _this.userProfile.userDetails.role = _this.roles[0];
                        _this.userProfileReset.userDetails.role = _this.roles[0];
                    }
                    else if (_this.roles.length > 1) {
                        for (var i = 0; i < _this.roles.length; i++) {
                            if (_this.roles[i].name === _this.MESSAGECONSTANTS.ROLES.RECRUITER) {
                                _this.userProfile.userDetails.role = angular.copy(_this.roles[i]);
                                _this.userProfileReset.userDetails.role = angular.copy(_this.roles[i]);
                            }
                        }
                    }
                }
                if (!((_this.roles.length === 1) && _this.isCompanyAdmin(_this.roles[0]))) {
                    _this.userProfile.userDetails.manager = _this.managerDetails;
                    _this.userProfileReset.userDetails.manager = _this.managerDetails;
                }
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
            //Setting the Phone number values to be true
            this.isValidMobileNumberEntered = true;
            this.isValidWorkTelephoneEntered = true;
            //Setting manager role id
            var managerToGetRoles = this.StorageService.get('managers');
            if (angular.isDefined(managerToGetRoles) && (managerToGetRoles !== null) && (managerToGetRoles.length > 0)) {
                managerId = managerToGetRoles[0].roleId;
            }
            if (this.isFourDotFiveAdmin(this.$rootScope.userDetails.roleScreenRef.role) || this.isSuperUser(this.$rootScope.userDetails.roleScreenRef.role)) {
                if (this.isFourDotFiveAdmin(this.$rootScope.userDetails.roleScreenRef.role) && this.isFourDotFiveAdmin(this.userProfileReset.userDetails.role)) {
                    this.roles = [];
                    this.roles.push(this.userProfileReset.userDetails.role);
                }
                else {
                    this.userService.getUserUpdateRoles(managerId, this.$rootScope.userDetails.company.companyType, function (data) {
                        _this.roles = data;
                        _this.form.userDetailsForm.$setPristine();
                    }, function (error) {
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
            }
            else {
                if (this.userProfile.userDetails.manager !== null) {
                    this.userService.getUserUpdateRoles(this.userProfileReset.userDetails.manager.roleId, this.$rootScope.userDetails.company.companyType, function (data) {
                        _this.roles = data;
                        _this.form.userDetailsForm.$setPristine();
                    }, function (error) {
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
                else {
                    this.roles.push(this.userProfile.userDetails.role);
                }
            }
            //get managers list
            if (!this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                this._getManagersList(angular.copy(this.userObject.userDetails.userId), angular.copy(this.userObject.userDetails.role.id), this.userObject.buId);
            }
            else {
                this.isLoading = false;
            }
        }
        else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
            this.roles.push(this.userProfile.userDetails.role);
        }
    };
    AddEditUserPageController.prototype._getManagersList = function (userId, roleId, buId) {
        var _this = this;
        if (!(this.isCorporateFlag && !_.isNull(buId) && buId !== "" && buId !== undefined)) {
            buId = null;
        }
        this.userService.getManagers(userId, roleId, buId, function (data) {
            _this.managerList = data;
            if ((_this.userProfile.userDetails.role.name === _this.MESSAGECONSTANTS.ROLESNAMES.FOURDOTFIVEADMIN_NAME)) {
                _this.managerList.push(_this.userProfile.userDetails.manager);
            }
            _this.isLoading = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            console.log('error : ' + angular.toJson(error));
        });
    };
    AddEditUserPageController.prototype._setDepartment = function () {
        if (!_.isNull(this.userProfile.departmentId)) {
            var department = {};
            department.id = this.userProfile.departmentId;
            department.name = this.userProfile.departmentName;
            this.selectedDepartmentObjectsArray.push(department);
        }
    };
    AddEditUserPageController.prototype.isWorkTelephoneValid = function (workTelephoneValue) {
        if (workTelephoneValue !== "") {
            if ($("#workTelephone").intlTelInput("isValidNumber")) {
                this.isValidWorkTelephoneEntered = true;
                this.userProfile.userDetails.workTelephone = this.$filter('phonenumber')(workTelephoneValue, this.telephoneNumberFormat);
                this.form.userDetailsForm.workTelephone.$setValidity('ng-intl-tel-input', true);
            }
            else {
                this.emptyUserworkTelephone = false;
                this.invalidUserworkTelephone = true;
                this.isValidWorkTelephoneEntered = false;
                this.workTelephoneValueTrim = document.getElementById('workTelephone').value;
                this.userProfile.userDetails.workTelephone = this.workTelephoneValueTrim.replace(/ |-/gm, '');
                this.form.userDetailsForm.workTelephone.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyUserworkTelephone = true;
            this.invalidUserworkTelephone = false;
            this.isValidWorkTelephoneEntered = false;
        }
    };
    AddEditUserPageController.prototype.isMobileNumberValid = function (mobileNumberValue) {
        if (mobileNumberValue !== "") {
            if ($("#mobileNumber").intlTelInput("isValidNumber")) {
                this.isValidMobileNumberEntered = true;
                this.userProfile.userDetails.mobileNumber = this.$filter('phonenumber')(mobileNumberValue, this.mobileNumberFormat);
                this.form.userDetailsForm.mobileNumber.$setValidity('ng-intl-tel-input', true);
            }
            else {
                this.emptyUsermobileNumber = false;
                this.invalidUsermobileNumber = true;
                this.isValidMobileNumberEntered = false;
                this.mobileNumberValueTrim = document.getElementById('mobileNumber').value;
                this.userProfile.userDetails.mobileNumber = this.mobileNumberValueTrim.replace(/ |-/gm, '');
                this.form.userDetailsForm.mobileNumber.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyUsermobileNumber = true;
            this.invalidUsermobileNumber = false;
            this.isValidMobileNumberEntered = false;
        }
    };
    //mobile number methods end
    AddEditUserPageController.prototype.getZipCodeDetails = function (zipcode, type) {
        var _this = this;
        this.nextButtonClicked = false;
        this.saveButtonClicked = false;
        if (this.form.userDetailsForm.zipcode.$valid) {
            this.zipCodeCalling = true;
            this.zipCodeCallCompleted = false;
            if (angular.isDefined(zipcode)) {
                this.cancelClicked = false;
            }
            this._getAddressDetails(zipcode, type, function (response) {
                if (angular.isDefined(_this.userProfileReset.userDetails.county) && (_this.userProfileReset.userDetails.county !== null)
                    && (_this.userProfile.userDetails.zipcode === _this.userProfileReset.userDetails.zipcode)) {
                    _this.userProfile.userDetails.county = _this.userProfileReset.userDetails.county;
                    // this.$scope.safeApply();
                }
                if (_this.saveButtonClicked) {
                    _this._saveButtonTrigger();
                }
                else if (_this.nextButtonClicked) {
                    _this._nextButtonTrigger();
                }
            });
        }
        else {
            this.geoLocations = [];
            this.saveButtonClicked = false;
            this.nextButtonClicked = false;
            this.userProfile.userDetails.city = '';
            this.userProfile.userDetails.state = '';
            this.userProfile.userDetails.county = '';
            this.isCountyExists = false;
            this.userProfile.userDetails.country = '';
        }
    };
    /**
    * This method works for triggerng button clicks on save button
    *  only for on blur validations
    */
    AddEditUserPageController.prototype._saveButtonTrigger = function () {
        var _this = this;
        var savebtnclick = this.$timeout(function () {
            angular.element('.btn-save').triggerHandler('click');
        }, 0).then(function () {
            _this.saveButtonClicked = false;
            _this.nextButtonClicked = false;
            _this.$timeout.cancel(savebtnclick);
        });
    };
    /**
     * This method works for triggerng button clicks on save button
     *  only for on blur validations
     */
    AddEditUserPageController.prototype._nextButtonTrigger = function () {
        var _this = this;
        var nextbtnclick = this.$timeout(function () {
            angular.element('.create-next').triggerHandler('click');
        }, 0).then(function () {
            _this.zipCodeCalling = false;
            _this.zipCodeCallCompleted = false;
            _this.nextButtonClicked = false;
            _this.saveButtonClicked = false;
            _this.$timeout.cancel(nextbtnclick);
        });
    };
    AddEditUserPageController.prototype._populateForwardRecipient = function () {
        if (!angular.equals(this.userProfile.userForwardRecipientDetails, null)) {
            if (!angular.equals(this.userProfile.userForwardRecipientDetails.forwardRecipient, null)) {
                if (angular.isDefined(this.userProfile.userForwardRecipientDetails.forwardRecipient.userId)) {
                    if (this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName != null) {
                        var output = this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName + ' ' + this.userProfile.userForwardRecipientDetails.forwardRecipient.lastName;
                    }
                    else {
                        var output = this.userProfile.userForwardRecipientDetails.forwardRecipient.firstName;
                    }
                    if (output.length > 57) {
                        this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output.substring(0, 57) + "...";
                    }
                    else {
                        this.userProfile.userForwardRecipientDetails.forwardRecipient["fullName"] = output;
                    }
                    this.forwardRecipients.push(angular.copy(this.userProfile.userForwardRecipientDetails.forwardRecipient));
                }
            }
        }
    };
    // Address methods end
    AddEditUserPageController.prototype._createWizard = function () {
        var _this = this;
        $(document).ready(function () {
            // var companyType = $('#hiddencompanyType').val();
            var companyType = _this.companyType;
            $('#hiddencompanyType').hide();
            var is4dot5Admin = localStorage.getItem('myStorage-4dot5Admin');
            console.log('is4dot5Admin : ' + is4dot5Admin);
            //var userDetails = getCookie('myStorage-userDetails');
            if ((companyType === 'Host') || is4dot5Admin) {
                console.log('removing 3rd step');
                $('#myWizard').wizard('removeSteps', 3, 1).on('actionclicked.fu.wizard', function (event, data) {
                    var wizardoperations = localStorage.getItem('myStorage-wizardoperations');
                    if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                        //console.log('preventing');
                        event.preventDefault();
                    }
                }).on('finished.fu.wizard', function (event, data) {
                    console.log('finished.fu.wizard : ');
                    // if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                    //     console.log('preventing');
                    //     event.preventDefault();
                    // }
                }).on('stepclicked.fu.wizard', function (event, data) {
                    console.log('stepclicked.fu.wizard : ');
                    // if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                    //     console.log('preventing');
                    //     event.preventDefault();
                    // }
                });
            }
            else {
                $('#myWizard').wizard()
                    .on('actionclicked.fu.wizard', function (event, data) {
                    var wizardoperations = localStorage.getItem('myStorage-wizardoperations');
                    //console.log('wizardoperations : '+wizardoperations);
                    if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                        //console.log('preventing');
                        event.preventDefault();
                    }
                }).on('changed.fu.wizard', function (event, data) {
                    console.log('changed.fu.wizard : ');
                    localStorage.removeItem('myStorage-wizardoperations');
                }).on('stepclicked.fu.wizard', function (event, data) {
                    console.log('stepclicked.fu.wizard : ');
                    // if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                    //     console.log('preventing');
                    //     event.preventDefault();
                    // }
                });
            }
            var currentDate = new Date();
            $('#fromDate').datepicker({
                format: 'M d, yyyy',
                startDate: currentDate,
                autoclose: true,
            });
            $('#toDate').datepicker({
                format: 'M d, yyyy',
                startDate: currentDate,
                autoclose: true
            });
            $('#fromTime').timepicker({
                minuteStep: 1,
                showSeconds: true,
                showMeridian: false,
                disableFocus: true,
                showWidget: true,
            }).focus(function () {
                $(_this).next().trigger('click');
            });
            // angular.element('#fromTime').trigger('click');
            $('#toTime').timepicker({
                minuteStep: 1,
                showSeconds: true,
                showMeridian: false,
                disableFocus: true,
                showWidget: true
                // defaultTime : true
            }).focus(function () {
                $(_this).next().trigger('click');
            });
            // angular.element('#fromTime').trigger('click');
            //masked inputs
            // $("#workTelephone").mask("9?99.999.999999999",{placeholder:" ",autoclear: false});
            /* $("#mobileNumber").mask("9?99.999.999999999",{placeholder:" ",autoclear: false}); */
            // $('#myWizard').bind("cut copy paste",function(e) {
            // 		e.preventDefault();
            // 	});
            $('.custom-file-upload').bind("click", function () {
                $('#inputImage').trigger('click');
            });
            $('#inputImage').change(function () {
                var filepath = $('#inputImage').val();
                var filename = filepath.split('\\').pop().split('/').pop(); //str.split('\\').pop().split('/').pop();
                $('#profilepicname').html(filename);
            });
        });
    };
    AddEditUserPageController.prototype._setWorkTelephoneCountryCode = function () {
        $("#workTelephone").intlTelInput("setCountry", this.countryCodeForTelephone);
        this.telephoneNumberFormat = document.getElementById("workTelephone").placeholder;
        // this.$scope.safeApply();
        this.isWorkTelephoneValid(document.getElementById("workTelephone").value);
    };
    AddEditUserPageController.prototype._setMobileNumberCountryCode = function () {
        $("#mobileNumber").intlTelInput("setCountry", this.countryCodeForTelephone);
        this.mobileNumberFormat = document.getElementById("mobileNumber").placeholder;
        // this.$scope.safeApply();
        this.isMobileNumberValid(document.getElementById("mobileNumber").value);
    };
    AddEditUserPageController.prototype._getESfor4dot5Admin = function (callback) {
        var _this = this;
        this.utilityService.getCompaniesforUser(angular.copy(this.userProfile.userDetails.role), angular.copy(this.userProfile.userDetails.userId)).then(function (data) {
            _this.userProfile.userScopeDetails = data;
            _this.userProfileReset.userScopeDetails = angular.copy(_this.userProfile.userScopeDetails);
            _this.StorageService.set('wizardoperations', true);
            _this.stepTrigger('nextbtnclick');
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    /**
    * This method works for triggerng
    * button clicks and resetting timeout
    * and remaining variables to normal
    * @access for create, view and update
    */
    AddEditUserPageController.prototype.stepTrigger = function (target) {
        var _this = this;
        if (target === 'nextbtnclick') {
            var nextbtnclick = this.$timeout(function () {
                if (_this.accessMode !== _this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
                    angular.element('.create-next').triggerHandler('click');
                }
                else {
                    angular.element('.view-next').triggerHandler('click');
                }
            }, 0).then(function () {
                _this.triggerCount = 0;
                _this.formSubmitted = false;
                _this.StorageService.remove('wizardoperations');
                if ((_this.userProfile.userDetails.role.name !== _this.MESSAGECONSTANTS.ROLES.FOURDOTFIVEADMIN) && _this.lastStep) {
                    _this.form.userForwardRecipientsform.$setPristine();
                }
                _this.$timeout.cancel(nextbtnclick);
            });
        }
        else if (target === 'cancelflow') {
            var steponeclick = this.$timeout(function () {
                angular.element('#1').trigger('click');
            }, 500).then(function () {
                _this.triggerCount = 0;
                _this.formSubmitted = false;
                _this.StorageService.remove('wizardoperations');
                _this.$timeout.cancel(steponeclick);
            });
        }
        else if (target === 'viewnext') {
            var viewnextbtnclick = this.$timeout(function () {
                angular.element('.view-next').triggerHandler('click');
            }, 0).then(function () {
                _this.StorageService.remove('wizardoperations');
                _this.triggerCount = 0;
                _this.$timeout.cancel(viewnextbtnclick);
            });
        }
    };
    AddEditUserPageController.prototype._createEntityScopeForAdmin = function () {
        var entityObj = {};
        entityObj.allIndustries = true;
        entityObj.allJobRequisitionTitleList = true;
        entityObj.allclientOrBU = true;
        entityObj.allBusOfClient = true;
        entityObj.requisitionCategory = false;
        entityObj.requisitionCategoryList = [];
        if (this.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.STAFFING) {
            entityObj.requisitionCategoryList[0] = {};
            entityObj.requisitionCategoryList[0].name = 'Retained';
            entityObj.requisitionCategoryList[0].isSelected = true;
            entityObj.requisitionCategoryList[1] = {};
            entityObj.requisitionCategoryList[1].name = 'Contingent';
            entityObj.requisitionCategoryList[1].isSelected = true;
            entityObj.requisitionCategoryList[2] = {};
            entityObj.requisitionCategoryList[2].name = 'Both';
            entityObj.requisitionCategoryList[2].isSelected = true;
        }
        else if (this.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            entityObj.requisitionCategoryList[0] = {};
            entityObj.requisitionCategoryList[0].name = 'Retained';
            entityObj.requisitionCategoryList[0].isSelected = true;
            entityObj.requisitionCategoryList[1] = {};
            entityObj.requisitionCategoryList[1].name = 'Contingent';
            entityObj.requisitionCategoryList[1].isSelected = true;
            entityObj.requisitionCategoryList[2] = {};
            entityObj.requisitionCategoryList[2].name = 'Both';
            entityObj.requisitionCategoryList[2].isSelected = true;
        }
        return entityObj;
    };
    AddEditUserPageController.prototype._parseRoleScopeDetails = function () {
        // if (this.userProfile.userScopeDetails.allclientOrBU) {
        // angular.forEach(this.userProfile.userScopeDetails.clientOrBUList[0], function(client, key) {
        //     client.selected = true;   
        // });
        // }
        // this.isClientListAndBuAll = this.isStaffingCompany && this.userProfile.userScopeDetails.allBusOfClient && !this.userProfile.userScopeDetails.allclientOrBU? true: false; 
        this.showClientList = !this.userProfile.userScopeDetails.allclientOrBU || (this.userProfile.userScopeDetails.allclientOrBU && !this.userProfile.userScopeDetails.userClientBUinfo.hasAllBuOrClientEnabledForParent) ? true : false;
        this.showBuList = !this.userProfile.userScopeDetails.allBusOfClient || (this.userProfile.userScopeDetails.allBusOfClient && !this.userProfile.userScopeDetails.userClientBUinfo.hasAllBuOfClientEnabledForParent) ? true : false;
    };
    AddEditUserPageController.prototype._getUserProfileInfo = function (successCallback) {
        var _this = this;
        var user = { userId: this.$stateParams.userId };
        this.utilityService.getUserProfile(user).then(function (data) {
            _this.userObject = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AddEditUserPageController.prototype._getAddressDetails = function (zipcode, type, callback) {
        var _this = this;
        this.validzipcode = true;
        var locations = [];
        console.log('zipcode : ' + zipcode);
        if (type != 'copycomanyaddress') {
            document.getElementById("copyCompanyAddress").checked = false;
        }
        this.copyCompanyAddress = false;
        var url = 'maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + this.MESSAGECONSTANTS.GEOCODING.API_KEY;
        if (angular.isDefined(zipcode) && !angular.equals(zipcode, '')) {
            $.getJSON({
                url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + this.MESSAGECONSTANTS.GEOCODING.API_KEY,
                data: {
                    sensor: false,
                },
                success: function (data, textStatus) {
                    var createGeoLocation = function (addressdetails, postalname) {
                        var addressobj = {};
                        for (var p = 0; p < addressdetails.address_components.length; p++) {
                            for (var t = 0; t < addressdetails.address_components[p].types.length; t++) {
                                switch (addressdetails.address_components[p].types[t]) {
                                    case 'country':
                                        addressobj.country = addressdetails.address_components[p].long_name;
                                        addressobj.countryCode = addressdetails.address_components[p].short_name;
                                        break;
                                    case 'administrative_area_level_2':
                                        addressobj.county = addressdetails.address_components[p].long_name;
                                        break;
                                    case 'administrative_area_level_1':
                                        addressobj.state = addressdetails.address_components[p].long_name;
                                        break;
                                    case 'locality':
                                        if (angular.isDefined(postalname) && postalname !== '') {
                                            addressobj.city = postalname;
                                        }
                                        else {
                                            addressobj.city = addressdetails.address_components[p].long_name;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                        if ((angular.isUndefined(addressobj.city) || angular.isUndefined(addressobj.state) || angular.isUndefined(addressobj.country))) {
                            for (var p = 0; p < addressdetails.address_components.length; p++) {
                                for (var t = 0; t < addressdetails.address_components[p].types.length; t++) {
                                    switch (addressdetails.address_components[p].types[t]) {
                                        case 'locality':
                                            if (angular.isUndefined(addressobj.state)) {
                                                addressobj.state = addressdetails.address_components[p].long_name;
                                            }
                                            if (angular.isUndefined(addressobj.country)) {
                                                addressobj.country = addressdetails.address_components[p].long_name;
                                                addressobj.countryCode = addressdetails.address_components[p].short_name;
                                            }
                                            break;
                                        case 'administrative_area_level_2':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            if (angular.isUndefined(addressobj.state)) {
                                                addressobj.state = addressdetails.address_components[p].long_name;
                                            }
                                            if (angular.isUndefined(addressobj.country)) {
                                                addressobj.country = addressdetails.address_components[p].long_name;
                                                addressobj.countryCode = addressdetails.address_components[p].short_name;
                                            }
                                            break;
                                        case 'administrative_area_level_3':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            break;
                                        case 'administrative_area_level_4':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            break;
                                        case 'sublocality' || 'sublocality_level_1' || 'sublocality_level_5':
                                            if (angular.isDefined(postalname) && postalname !== '') {
                                                addressobj.city = postalname;
                                            }
                                            else {
                                                addressobj.city = addressdetails.address_components[p].long_name;
                                            }
                                            break;
                                        case 'administrative_area_level_1':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                                if (angular.isUndefined(addressobj.country)) {
                                                    addressobj.country = addressdetails.address_components[p].long_name;
                                                    addressobj.countryCode = addressdetails.address_components[p].short_name;
                                                }
                                            }
                                            break;
                                    }
                                }
                            }
                        }
                        if (angular.isUndefined(addressobj.county)) {
                            addressobj.county = null;
                        }
                        return addressobj;
                    };
                    var checkCountyExists = function (locations, profile) {
                        for (var i = 0; i < locations.length; i++) {
                            if (angular.equals(locations[i].city, profile.userDetails.city) &&
                                angular.isDefined(locations[i].county) && (locations.county !== null) &&
                                angular.isDefined(profile.userDetails.county) &&
                                (profile.userDetails.county !== null) && angular.equals(locations[i].county, profile.userDetails.county)) {
                                return true;
                            }
                        }
                        return false;
                    };
                    if (data.status === 'OK') {
                        console.log('data.status OK');
                        _this.validzipcode = true;
                        for (var i = 0; i < data.results.length; i++) {
                            if (angular.isDefined(data.results[i].postcode_localities) && (data.results[i].postcode_localities.length > 0)) {
                                for (var k = 0; k < data.results[i].postcode_localities.length; k++) {
                                    if ((data.results[i].types[0] === 'postal_code')) {
                                        var location = createGeoLocation(data.results[i], data.results[i].postcode_localities[k]);
                                        locations.push(angular.copy(location));
                                    }
                                }
                            }
                            else {
                                if ((data.results[i].types[0] === 'postal_code')) {
                                    var location = createGeoLocation(data.results[i]);
                                    locations.push(angular.copy(location));
                                }
                            }
                        }
                        if ((type === 'zipchanged') && !_this.cancelClicked && locations.length) {
                            console.log('zipchanged && !this.cancelClicked && locations.length');
                            _this.userProfile.userDetails.city = locations[0].city;
                            _this.userProfile.userDetails.state = locations[0].state;
                            _this.userProfile.userDetails.county = locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.userProfile.userDetails.country = locations[0].country;
                            _this.countryCodeForTelephone = locations[0].countryCode;
                            _this.countryCodeForTelephone = locations[0].countryCode;
                            _this._setWorkTelephoneCountryCode();
                            _this._setMobileNumberCountryCode();
                            _this.zipCodeCallCompleted = true;
                        }
                        else if ((type === 'copycomanyaddress') && !_this.cancelClicked && locations.length) {
                            console.log('copycomanyaddress && !this.cancelClicked && locations.length');
                            _this.userProfile.userDetails.city = locations[0].city;
                            _this.userProfile.userDetails.state = locations[0].state;
                            _this.userProfile.userDetails.county = locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.userProfile.userDetails.country = locations[0].country;
                            _this.countryCodeForTelephone = locations[0].countryCode;
                            _this.countryCodeForTelephone = locations[0].countryCode;
                            _this._setWorkTelephoneCountryCode();
                            _this._setMobileNumberCountryCode();
                            _this.zipCodeCallCompleted = true;
                        }
                        else if (_this.cancelClicked) {
                            locations = angular.copy(_this.copyOfGeoLocationsCopy);
                            _this.geoLocations = angular.copy(_this.copyOfGeoLocationsCopy);
                            console.log('in this.cancelClicked this.geoLocations :' + angular.toJson(locations));
                            _this.userProfile.userDetails.city = _this.userProfileReset.userDetails.city;
                            _this.userProfile.userDetails.state = _this.userProfileReset.userDetails.state;
                            _this.userProfile.userDetails.county = _this.userProfileReset.userDetails.county;
                            if (checkCountyExists(angular.copy(locations), angular.copy(_this.userProfileReset))) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.userProfile.userDetails.country = _this.userProfileReset.userDetails.country;
                            _this.zipCodeCallCompleted = true;
                        }
                        else if (locations.length) {
                            console.log('locations.length with locations : ' + angular.toJson(locations));
                            console.log('this.userProfileReset.userDetails : ' + angular.toJson(_this.userProfileReset.userDetails));
                            if (checkCountyExists(angular.copy(locations), angular.copy(_this.userProfileReset))) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                                /**
                                 * enters when clicked on cancel in create flow
                                 */
                                _this.userProfile.userDetails.workTelephone = angular.copy(_this.userProfileReset.userDetails.workTelephone);
                                _this.userProfile.userDetails.mobileNumber = angular.copy(_this.userProfileReset.userDetails.mobileNumber);
                            }
                            else if ((_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) || (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.VIEW)) {
                                /**
                                 * enters when starting of update flow
                                 */
                                _this.userProfile.userDetails.workTelephone = angular.copy(_this.userObject.userDetails.workTelephone);
                                _this.userProfile.userDetails.mobileNumber = angular.copy(_this.userObject.userDetails.mobileNumber);
                            }
                            _this.zipCodeCallCompleted = true;
                        }
                    }
                    else {
                        console.log('else');
                        if (!_this.cancelClicked) {
                            console.log('!this.cancelClicked');
                            _this.validzipcode = false;
                            locations = [];
                            _this.geoLocations = [];
                            _this.userProfile.userDetails.city = '';
                            _this.userProfile.userDetails.state = '';
                            _this.userProfile.userDetails.county = '';
                            _this.isCountyExists = false;
                            _this.userProfile.userDetails.country = '';
                            _this.zipCodeCallCompleted = true;
                        }
                        else {
                            console.log('!this.cancelClicked else');
                            locations = angular.copy(_this.copyOfGeoLocationsCopy);
                            _this.geoLocations = angular.copy(_this.copyOfGeoLocationsCopy);
                            _this.userProfile.userDetails.city = _this.userProfileReset.userDetails.city;
                            _this.userProfile.userDetails.state = _this.userProfileReset.userDetails.state;
                            _this.userProfile.userDetails.county = _this.userProfileReset.userDetails.county;
                            if (checkCountyExists(angular.copy(locations), angular.copy(_this.userProfileReset))) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.userProfile.userDetails.country = _this.userProfileReset.userDetails.country;
                            _this.zipCodeCallCompleted = true;
                        }
                    }
                    _this.geoLocations = angular.copy(locations);
                    if (!_this.geoLocations.length) {
                        console.log('!this.geoLocations.length');
                        _this.validzipcode = false;
                        _this.userProfile.userDetails.city = '';
                        _this.userProfile.userDetails.state = '';
                        _this.userProfile.userDetails.county = '';
                        _this.isCountyExists = false;
                        _this.userProfile.userDetails.country = '';
                        _this.zipCodeCallCompleted = true;
                    }
                    console.log('this.geoLocations : ' + angular.toJson(_this.geoLocations));
                    _this.$scope.$apply();
                    if (type === 'start') {
                        // this.form.userDetailsForm.$setPristine();
                    }
                    if (typeof callback != "undefined") {
                        return callback(_this.geoLocations);
                    }
                },
                error: function (data) {
                    _this.validzipcode = false;
                    _this.geoLocations = [];
                    _this.isCountyExists = false;
                    if (typeof callback != "undefined") {
                        return callback('success');
                    }
                }
            });
        }
        else {
            this.geoLocations = [];
            this.isCountyExists = false;
            if (typeof callback != "undefined") {
                return callback('success');
            }
        }
    };
    /**
     * This method gets all managers list while demoting company admin and assign to scope variable
     * @access for update
     */
    AddEditUserPageController.prototype._getManagerListWhileDemotingAdmin = function (userId) {
        var _this = this;
        var buId = null;
        if (this.isCorporateFlag && !_.isNull(this.userProfile.buId) && this.userProfile.buId !== "" && this.userProfile.buId !== undefined) {
            buId = this.userProfile.buId;
        }
        this.userService.getManagersWhileDemotingAdmin(userId, this.$rootScope.userDetails.company.companyId, this.userProfile.userDetails.role.id, buId, function (data) {
            if (data.length === 0) {
                _this.alertsAndNotificationsService.showBannerMessage('Cannot change the role of the only existing Admin !', 'danger');
                _this.userProfile.userDetails.role = angular.copy(_this.userProfileReset.userDetails.role);
                _this.form.userScopeDetailsform.$setPristine();
            }
            else {
                _this.managerList = data;
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            console.log('error : ' + angular.toJson(error));
        });
    };
    // var assignOrChangeManager = function (managerid, userid) {
    //     genericService.addObject(this.USERMANAGEMENTCONSTANTS.CONTROLLER.ASSIGN_MANAGER + '/' + managerid + '/' + userid).then(function (data) {
    //         this.userProfile.userDetails.manager = angular.copy(data.userDetails.manager);
    //         if (!angular.equals(this.userProfile.userDetails.manager, null) && !angular.equals(this.userProfile.userDetails.manager.lastName, null)) {
    //             this.userProfile.userDetails.manager.firstName = this.userProfile.userDetails.manager.firstName + ' ' + this.userProfile.userDetails.manager.lastName;
    //         }
    //         this.userProfileReset = angular.copy(this.userProfile);
    //         this.form.userDetailsForm.$setPristine();
    //     }, function (error) {
    //     	if(this.$rootScope.isOnline){
    //         	this.alertsAndNotificationsService.showBannerMessage(error.message,'danger');
    //         }
    //         this.userProfile.userDetails.manager = angular.copy(this.userProfileReset.userDetails.manager);
    //     });
    // };
    /**
     * This method helps to go to next step by checking
     * what are all the data needed for next step
     * @access for only view access
     */
    AddEditUserPageController.prototype.getNextStepData = function () {
        var _this = this;
        if (this.triggerCount === 0) {
            this.nextButtonClicked = false;
            this.saveButtonClicked = false;
            this.triggerCount = angular.copy(this.triggerCount + 1);
            this.currentstep = this._getCurrentStep();
            this.StorageService.remove('wizardoperations');
            if (this.currentstep === 1) {
                this._getEntityScopeDetails();
            }
            else if (this.currentstep === 2) {
                this.triggerCount = 0;
                this.$timeout(function () {
                    _this.StorageService.remove('wizardoperations');
                    if (angular.copy(_this.$stateParams.purpose) !== null) {
                        _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                    }
                    else {
                        _this._goToUsersPage();
                    }
                }, 500);
            }
        }
    };
    AddEditUserPageController.prototype._getCurrentStep = function () {
        return $('#myWizard').wizard('selectedItem').step;
    };
    /**
     * This method gets all entity scope datails
     * based on company type.
     * Assign to scope variable and finally when leaving
     * from step assign values to userProfile object.
     * @access for only create. No need for view and edit access as
     * details will be a part of user object
     */
    AddEditUserPageController.prototype._getEntityScopeDetails = function () {
        var _this = this;
        this.StorageService.remove('wizardoperations');
        if (this.isInHost) {
            this._getESfor4dot5Admin();
        }
        else if (this.isFourDotFiveAdmin(this.userProfile.userDetails.role)) {
            this.userProfile.userScopeDetails = this._createEntityScopeForAdmin();
            this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
            this.lastStep = true;
            this.nextButtonClicked = false;
            this.saveButtonClicked = false;
            this.StorageService.set('wizardoperations', true);
            this.stepTrigger('nextbtnclick');
        }
        else {
            // if((this.userProfile.userScopeDetails === null) || (this.roleChanged) || (this.managerChanged) || (this.isUserBelongsToBUChanged)){
            this.utilityService.getUserRoleEntityScope(angular.copy(this.userProfile)).then(function (data) {
                _this.userProfile.userScopeDetails = data;
                _this._parseRoleScopeDetails();
                _this.userProfileReset.userScopeDetails = angular.copy(_this.userProfile.userScopeDetails);
                _this.StorageService.set('wizardoperations', true);
                _this.stepTrigger('nextbtnclick');
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                console.log('error');
            });
            // }else{
            //     this.StorageService.set('wizardoperations', true);
            //     this.stepTrigger('nextbtnclick');
            // }
        }
    };
    /**
     * This method will be called whenever user clicked on 'NEXT' buttton
     * This method checks whether any changes are made in UI with respective steps
     */
    AddEditUserPageController.prototype.manageStepData = function () {
        var _this = this;
        if (this.triggerCount === 0) {
            this.StorageService.remove('wizardoperations');
            this.triggerCount = angular.copy(this.triggerCount + 1);
            this.formSubmitted = true;
            this.nextButtonClicked = true;
            this.saveButtonClicked = false;
            this.valid = false;
            var currentStep = this._getCurrentStep();
            switch (currentStep) {
                case 1:
                    this.valid = this.form.userDetailsForm.$valid && !this.utilityService.isContentinObjSame(this.userProfile.userDetails.address1, this.userProfile.userDetails.address2) && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered && (!this.zipCodeCalling || (this.zipCodeCalling && this.zipCodeCallCompleted));
                    // no check for step data change as save is to be called to handle "User belongs to BU" where Bu has to be preselected in the scope
                    if (this.valid && this.accessMode !== this.MESSAGECONSTANTS.ACCESS_MODES.VIEW && this._hasStepDataChanged(currentStep)) {
                        this.lastStep = false;
                        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                            var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.SAVE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                        }
                        else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                            var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                        }
                        this._manageUserDetails(url);
                    }
                    else if (this.valid) {
                        this._getEntityScopeDetails();
                    }
                    else {
                        this.form.userDetailsForm.workTelephone.visited = true;
                        this.form.userDetailsForm.mobileNumber.visited = true;
                        this.triggerCount = 0;
                    }
                    break;
                case 2:
                    this.valid = this.form.userDetailsForm.$valid && this.form.userScopeDetailsform.$valid && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
                    if (this.valid && !this._hasStepDataChanged(currentStep)) {
                        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                            if (!this.userCreated) {
                                this.userCreated = true;
                                if ((this.nextButtonFlag > 0) && (this.recentButtonClick === 'nextButton')) {
                                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CREATESUCCESS, 'success');
                                }
                            }
                            else {
                                if ((this.nextButtonFlag > 0) && (this.recentButtonClick === 'nextButton')) {
                                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
                                }
                            }
                            this.managerDetails.firstName = this.managerDetails.firstName.split(" ")[0];
                            var managerReturnObj = this.managerDetails;
                        }
                        else {
                            if ((this.nextButtonFlag > 0) && (this.recentButtonClick === 'nextButton')) {
                                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                            }
                            else {
                                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.NOTHING_UPDATED + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' ", 'success');
                            }
                            var managerReturnObj = this.originalManagerObj;
                        }
                        this.$timeout(function () {
                            _this.StorageService.remove('wizardoperations');
                            if (angular.copy(_this.$stateParams.purpose) !== null) {
                                _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                            }
                            else {
                                _this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
                            }
                        }, 500);
                    }
                    else if (this.valid) {
                        this._manageUserScopeDetails();
                    }
                    else {
                        this.triggerCount = 0;
                    }
                    break;
                default:
                    this.text = "Something went wrong";
            }
        }
    };
    AddEditUserPageController.prototype._hasStepDataChanged = function (stepno) {
        switch (stepno) {
            case 1: return !angular.equals(this.userProfile, this.userProfileReset) && this.form.userDetailsForm.$dirty;
            case 2: return !angular.equals(this.userProfile.userScopeDetails, this.userProfileReset.userScopeDetails);
            default: this.alertsAndNotificationsService.showBannerMessage('Something went wrong.. Please contact system admin.', 'danger');
        }
    };
    /**
     * This method will be called from manageStepData() if some thing is changed on ui in step1;
     * This method deals with saving of user step1 details and assigning manager for saved user.
     * @access to CREATE MODE and EDIT MODE when clicked on 'NEXT' Button
     */
    AddEditUserPageController.prototype._manageUserDetails = function (url) {
        var _this = this;
        var roleOrManagerChangeCheck = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (roleOrManagerChangeCheck) {
            this._getChangesForRoleAndManager();
        }
        this.utilityService.saveUserProfileObject(url, angular.copy(this.userProfile)).then(function (data) {
            _this.formSubmitted = false;
            _this.userProfile = data;
            _this.nextButtonFlag++;
            _this.recentButtonClick = 'nextButton';
            _this.nextButtonClicked = false;
            _this._showUserDetailsSaveMessage('next');
            _this.geoLocationsCopy = angular.copy(_this.geoLocations);
            _this.userProfileReset = angular.copy(_this.userProfile);
            _this.form.userDetailsForm.$setPristine();
            _this._getEntityScopeDetails();
        }, function (error) {
            _this.triggerCount = 0;
            _this.formSubmitted = false;
            if (error.statusCode === '410') {
                if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                    if (angular.isDefined(_this.managerDetails) && !angular.equals(_this.managerDetails, null) && !angular.equals(_this.managerDetails.lastName, null)) {
                        _this.managerDetails.firstName = _this.managerDetails.firstName.split(" ")[0];
                    }
                    var managerReturnObj = _this.managerDetails;
                }
                else if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    var managerReturnObj = _this.originalManagerObj;
                }
                _this.StorageService.remove('wizardoperations');
                if (angular.copy(_this.$stateParams.purpose) !== null) {
                    _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                }
                else {
                    _this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
                }
            }
            else {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                if (_this._isRoleExistsforUser() && _this._isManagerExistsforUser()) {
                    _this.userProfile.userDetails = angular.copy(_this.userProfileReset.userDetails);
                }
            }
        });
    };
    AddEditUserPageController.prototype._isRoleExistsforUser = function () {
        return angular.isDefined(this.userProfile.userDetails) && angular.isDefined(this.userProfileReset.userDetails) &&
            (this.userProfile.userDetails !== null) && (this.userProfileReset.userDetails !== null) &&
            angular.isDefined(this.userProfile.userDetails.role) && angular.isDefined(this.userProfileReset.userDetails.role) &&
            (this.userProfile.userDetails.role !== null) && (this.userProfileReset.userDetails.role !== null);
    };
    AddEditUserPageController.prototype._isManagerExistsforUser = function () {
        return this._isRoleExistsforUser() &&
            angular.isDefined(this.userProfile.userDetails.manager) && angular.isDefined(this.userProfileReset.userDetails.manager);
    };
    AddEditUserPageController.prototype._getChangesForRoleAndManager = function () {
        if (!angular.equals(this.userProfile.userDetails.role, this.userProfileReset.userDetails.role)) {
            this.roleChanged = true;
            this.oldRole = angular.copy(this.userProfileReset.userDetails.role);
        }
        else {
            this.roleChanged = false;
            this.oldRole = null;
        }
        if (!angular.equals(this.userProfile.userDetails.manager, this.userProfileReset.userDetails.manager)) {
            this.managerChanged = true;
            this.oldManager = angular.copy(this.userProfileReset.userDetails.manager);
        }
        else {
            this.managerChanged = false;
            this.oldManager = null;
        }
    };
    AddEditUserPageController.prototype._showUserDetailsSaveMessage = function (buttonclicked) {
        var userDetailsSaveMessageCheck = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (userDetailsSaveMessageCheck) {
            if (this.roleChanged && this.managerChanged) {
                if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                    var successmessage = "The role for the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was successfully changed from '<b><i class='wrap-word'>" + this.oldRole.description + "</i></b>' to '<b><i class='wrap-word'>" + this.userProfile.userDetails.role.description + "</i></b>' <br> " +
                        "The manager of the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' has been set to '<b><i class='wrap-word'>" +
                        this.getFullName(this.userProfile.userDetails.manager.firstName, null) + "</i></b>'.";
                }
                else {
                    var successmessage = "The role for the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was successfully changed from '<b><i class='wrap-word'>" + this.oldRole.description + "</i></b>' to '<b><i class='wrap-word'>" + this.userProfile.userDetails.role.description + "</i></b>' <br> " +
                        "The manager of the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was changed from '<b><i class='wrap-word'>" +
                        this.getFullName(this.oldManager.firstName, null) + "</i></b>' to '<b><i class='wrap-word'>" +
                        this.getFullName(this.userProfile.userDetails.manager.firstName, null) + "</i></b>'.";
                }
                this.alertsAndNotificationsService.showBannerMessage(successmessage, 'success');
            }
            else if (this.roleChanged) {
                var successmessage = "The role for the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was successfully changed from '<b><i class='wrap-word'>" + this.oldRole.description + "</i></b>' to '<b><i class='wrap-word'>" + this.userProfile.userDetails.role.description + "'.";
                this.alertsAndNotificationsService.showBannerMessage(successmessage, 'success');
            }
            else if (this.managerChanged) {
                var successmessage = "The manager of the user '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' was changed from '<b><i class='wrap-word'>" +
                    this.getFullName(this.oldManager.firstName, null) + "</i></b>' to '<b><i class='wrap-word'>" +
                    this.getFullName(this.userProfile.userDetails.manager.firstName, null) + "</i></b>'.";
                this.alertsAndNotificationsService.showBannerMessage(successmessage, 'success');
            }
            else if (buttonclicked === 'save') {
                if ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE)) {
                    if (this.userCreated) {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
                    }
                    else {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CREATESUCCESS, 'success');
                    }
                }
                else {
                    if (this.isLoggedInUser(this.userProfile.userDetails)) {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.OWN_PROFILE_UPDATE, 'success');
                    }
                    else {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName) + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                    }
                }
            }
        }
    };
    /**
     * This method will be called from manageStepData() if some thing is changed on ui in step2;
     * This method deals with saving of user step2 details.
     * @access to CREATE MODE and EDIT MODE when clicked on 'NEXT' Button
     */
    AddEditUserPageController.prototype._manageUserScopeDetails = function () {
        var _this = this;
        //this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
        this.utilityService.setUserRoleEntityScope(angular.copy(this.userProfile)).then(function (data) {
            _this.userProfile = data;
            _this.nextButtonFlag++;
            _this.recentButtonClick = 'nextButton';
            _this.nextButtonClicked = false;
            _this.userProfileReset = angular.copy(_this.userProfile);
            _this.form.userScopeDetailsform.$setPristine();
            if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                if (!_this.userCreated) {
                    _this.userCreated = true;
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + _this.getFullName(_this.userProfile.userDetails.firstName, _this.userProfile.userDetails.lastName) + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CREATESUCCESS, 'success');
                }
                else {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + _this.getFullName(_this.userProfile.userDetails.firstName, _this.userProfile.userDetails.lastName) + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
                }
                _this.managerDetails.firstName = _this.managerDetails.firstName.split(" ")[0];
                var managerReturnObj = _this.managerDetails;
            }
            else {
                if (angular.copy(_this.$stateParams.purpose) !== null) {
                    _this.StorageService.remove('wizardoperations');
                    _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                }
                else {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i>" + _this.getFullName(_this.userProfile.userDetails.firstName, _this.userProfile.userDetails.lastName) + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                    var managerReturnObj = _this.originalManagerObj;
                }
            }
            _this.StorageService.remove('wizardoperations');
            _this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
            _this.userService.userCache(null, function () { }, function () { });
        }, function (error) {
            _this.triggerCount = 0;
            _this.formSubmitted = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            _this.userProfile.userScopeDetails = angular.copy(_this.userProfileReset.userScopeDetails);
        });
    };
    /**
     * This method will be called whenever user clicked on 'SAVE' buttton
     * This method checks whether any changes are made in UI with respective steps
     */
    AddEditUserPageController.prototype.saveStepData = function () {
        this.formSubmitted = true;
        this.nextButtonClicked = false;
        this.saveButtonClicked = true;
        this.valid = false;
        var currentStep = this._getCurrentStep();
        switch (currentStep) {
            case 1:
                //Cheking mobile and telephone validations also.
                this.valid = this.form.userDetailsForm.$valid && !this.utilityService.isContentinObjSame(this.userProfile.userDetails.address1, this.userProfile.userDetails.address2) && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered && (!this.zipCodeCalling || (this.zipCodeCalling && this.zipCodeCallCompleted));
                if (this.valid && !this._hasStepDataChanged(currentStep)) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.formSubmitted = false;
                    this.saveButtonClicked = false;
                }
                else if (this.valid) {
                    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                        var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.SAVE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                    }
                    else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                        var url = this.USERMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_USER + '/' + this.$rootScope.userDetails.company.companyId;
                    }
                    this._saveUserDetails(url);
                }
                else {
                    this.form.userDetailsForm.workTelephone.visited = true;
                    this.form.userDetailsForm.mobileNumber.visited = true;
                }
                break;
            case 2:
                this.valid = this.form.userDetailsForm.$valid && this.form.userScopeDetailsform.$valid && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
                if (this.valid && !this._hasStepDataChanged(currentStep)) {
                    this.formSubmitted = false;
                    this.saveButtonClicked = false;
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                }
                else if (this.valid) {
                    this._saveUserScopeDetails();
                }
                break;
            default:
                this.text = "Something went wrong";
        }
    };
    /**
     * This method will be called from saveStepData() if some thing is changed on ui in step1;
     * This method deals with saving of user step1 details and assigning manager for saved user.
     * @access to CREATE MODE and EDIT MODE when clicked on 'SAVE' Button
     */
    AddEditUserPageController.prototype._saveUserDetails = function (url) {
        var _this = this;
        var roleOrManagerChangeCheck = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (roleOrManagerChangeCheck) {
            this._getChangesForRoleAndManager();
        }
        this.utilityService.saveUserProfileObject(url, angular.copy(this.userProfile)).then(function (data) {
            _this.formSubmitted = false;
            _this.userProfile = data;
            _this.saveButtonFlag++;
            _this.recentButtonClick = 'saveButton';
            _this.saveButtonClicked = false;
            _this._showUserDetailsSaveMessage('save');
            _this.geoLocationsCopy = angular.copy(_this.geoLocations);
            _this.userProfileReset = angular.copy(_this.userProfile);
            if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                _this.userCreated = true;
            }
            else {
                _this.userCreated = false;
            }
            _this.form.userDetailsForm.$setPristine();
        }, function (error) {
            _this.triggerCount = 0;
            _this.formSubmitted = false;
            if (error.statusCode === '410') {
                if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
                    if (angular.isDefined(_this.managerDetails) && !angular.equals(_this.managerDetails, null) && !angular.equals(_this.managerDetails.lastName, null)) {
                        _this.managerDetails.firstName = _this.managerDetails.firstName.split(" ")[0];
                    }
                    var managerReturnObj = _this.managerDetails;
                }
                else if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                    var managerReturnObj = _this.originalManagerObj;
                }
                _this.StorageService.remove('wizardoperations');
                if (angular.copy(_this.$stateParams.purpose) !== null) {
                    _this.$state.go('missioncontrol.dashboard', null, { reload: true });
                }
                else {
                    _this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
                }
            }
            else {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                if (_this._isRoleExistsforUser() && _this._isManagerExistsforUser()) {
                    _this.userProfile.userDetails = angular.copy(_this.userProfileReset.userDetails);
                }
            }
        });
    };
    /**
     * This method will be called from saveStepData() if some thing is changed on ui in step2;
     * This method deals with saving of user step2 details.
     * @access to CREATE MODE and EDIT MODE when clicked on 'SAVE' Button
     */
    AddEditUserPageController.prototype._saveUserScopeDetails = function (url) {
        var _this = this;
        //this.userProfileReset.userScopeDetails = angular.copy(this.userProfile.userScopeDetails);
        this.utilityService.setUserRoleEntityScope(angular.copy(this.userProfile)).then(function (data) {
            _this.userProfile = angular.copy(data);
            _this.saveButtonFlag++;
            _this.recentButtonClick = 'saveButton';
            _this.saveButtonClicked = false;
            _this.userProfileReset = angular.copy(_this.userProfile);
            _this.form.userScopeDetailsform.$setPristine();
            if (_this.accessMode === _this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                if (_this.isLoggedInUser(_this.userProfile.userDetails)) {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.USER.OWN_PROFILE_UPDATE, 'success');
                }
                else {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + _this.getFullName(_this.userProfile.userDetails.firstName, _this.userProfile.userDetails.lastName) + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.USER.UPDATESUCCESS, 'success');
                }
            }
            else {
                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER + " '<b><i class='wrap-word'>" + _this.getFullName(_this.userProfile.userDetails.firstName, _this.userProfile.userDetails.lastName) + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.USER.SAVESUCCESS, 'success');
            }
            _this.roleChanged = false;
            _this.managerChanged = false;
            _this.userService.userCache(null, function () { }, function () { });
        }, function (error) {
            _this.triggerCount = 0;
            _this.formSubmitted = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            _this.userProfile.userScopeDetails = angular.copy(_this.userProfileReset.userScopeDetails);
        });
    };
    /**
     * This method is called, when user clicked on 'PREV' button
     * This will take care of changes to be made to 'userProfile' object when step changes
     */
    AddEditUserPageController.prototype.prevStepClicked = function () {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        var currentStep = this._getCurrentStep();
        switch (currentStep) {
            case 1:
                break;
            case 2:
                this.StorageService.set('wizardoperations', true);
                this.lastStep = false;
                break;
            default:
                this.text = "Something went wrong";
        }
    };
    /**
     * This method is called when user clicks on
     * cancel button.
     * This method works according to access permissions
     * of user when he enters into this module.
     * @access for create, view and update
     */
    AddEditUserPageController.prototype.cancel = function () {
        var _this = this;
        var currentStep = this._getCurrentStep();
        if (this._hasStepDataChanged(currentStep)) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this.clearData();
                        _this._goToUsersPage();
                    }
                    else {
                        _this.showConfirmationPopup = false;
                        _this.$rootScope.switchClicked = false;
                    }
                }
            });
        }
        else {
            this._goToUsersPage();
        }
    };
    AddEditUserPageController.prototype._goToUsersPage = function () {
        var managers = this.StorageService.get('managers');
        if (!_.isNull(managers) && managers !== undefined && managers.length > 0) {
            this.$state.go('missioncontrol.teamMembers', { managerObj: managers[managers.length - 1] }, { reload: false });
        }
        else {
            this.$state.go('missioncontrol.teamMembers', { reload: true });
        }
    };
    AddEditUserPageController.prototype.clearData = function () {
        this.cancelClicked = false;
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        this.copyOfGeoLocations = angular.copy(this.geoLocations);
        this.copyOfGeoLocationsCopy = angular.copy(this.geoLocationsCopy);
        var currentStep = this._getCurrentStep();
        this.showConfirmationPopup = false;
        this.$rootScope.switchClicked = false;
        switch (currentStep) {
            case 1:
                if (this._hasStepDataChanged(currentStep)) {
                    this.cancelClicked = true;
                    this.formSubmitted = false;
                    if (!angular.equals(this.userProfile.userDetails.zipcode, this.userProfileReset.userDetails.zipcode)) {
                        console.log('getAddressDetails with zipchanged');
                        this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'zipchanged');
                    }
                    else {
                        console.log('getAddressDetails with start');
                        this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'start');
                    }
                    this.userProfile = angular.copy(this.userProfileReset);
                    if (!angular.equals(this.userProfile.userDetails, {}) && angular.isDefined(this.userProfile.userDetails.userId) && angular.isDefined(this.userProfile.userDetails.role)) {
                        this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
                    }
                    else {
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                    if (angular.isDefined(this.userProfileReset.userDetails.workTelephone) && (this.userProfileReset.userDetails.workTelephone !== null)) {
                        document.getElementById("workTelephone").value = this.userProfileReset.userDetails.workTelephone;
                        // this.$scope.safeApply();
                        this._setWorkTelephoneCountryCode();
                    }
                    if (angular.isDefined(this.userProfileReset.userDetails.mobileNumber) && (this.userProfileReset.userDetails.mobileNumber !== null)) {
                        document.getElementById("mobileNumber").value = this.userProfileReset.userDetails.mobileNumber;
                        // this.$scope.safeApply();
                        this._setMobileNumberCountryCode();
                    }
                    this.form.userDetailsForm.$setPristine();
                    console.log('this.isCountyExists : ' + this.isCountyExists);
                }
                else {
                    this.formSubmitted = false;
                    if (angular.equals(this.userProfile.userDetails, {})) {
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this.countryCodeForTelephone = angular.copy(this.$rootScope.defaultCountryCode);
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                        this.isValidWorkTelephoneEntered = false;
                        this.isValidMobileNumberEntered = false;
                    }
                    else {
                    }
                    this.form.userDetailsForm.$setPristine();
                }
                angular.element('.companyaddresscopyenabled').attr({ 'readonly': false, 'disabled': false });
                break;
            case 2:
                if (this._hasStepDataChanged(currentStep)) {
                    this.cancelClicked = true;
                    this.formSubmitted = false;
                    this.userProfile = angular.copy(this.userProfileReset);
                    this.form.userScopeDetailsform.$setPristine();
                }
                break;
            default:
                this.cancelClicked = false;
                alert("Something went wrong...Please Logout and try again");
        }
    };
    AddEditUserPageController.prototype.cancelSteps = function () {
        this.cancel();
    };
    /**
     * This method is called, when user clicked on 'Step Names' directly
     * This will take care of changes to be made to 'userProfile' object when step changes
     */
    AddEditUserPageController.prototype.getStepChanges = function (stepclicked) {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        switch (stepclicked) {
            case 1:
                this.lastStep = false;
                break;
            case 2:
                this.lastStep = true;
                break;
            default:
                this.lastStep = false;
                console.log('something went wrong');
        }
    };
    //form changes
    /**
    * This method will be called when ever role is changed from ui
    */
    AddEditUserPageController.prototype.changeRoleObject = function () {
        var _this = this;
        var roleId = angular.copy(this.userProfile.userDetails.role.id);
        for (var i = 0; i < this.roles.length; i++) {
            if (roleId === this.roles[i].id) {
                this.userProfile.userDetails.role = angular.copy(this.roles[i]);
            }
        }
        var isRoleChangeValid = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (isRoleChangeValid && (this.userProfile.userDetails.role.id !== this.userProfileReset.userDetails.role.id)) {
            if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
                this.userProfile.userDetails.manager = null;
                var buId = null;
                if (this.isCorporateFlag && !_.isNull(this.userProfile.buId) && this.userProfile.buId !== "" && this.userProfile.buId !== undefined) {
                    buId = this.userProfile.buId;
                }
                this.userService.getManagersWhileDemotingAdmin(this.userProfileReset.userDetails.userId, this.$rootScope.userDetails.company.companyId, this.userProfile.userDetails.role.id, buId, function (data) {
                    if (data.length === 0) {
                        _this._showRoleChangeAlert('Cannot change the role of the only existing Admin.');
                    }
                    else {
                        _this._checkRoleChange();
                    }
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
            else {
                this._checkRoleChange();
            }
        }
        else if (isRoleChangeValid) {
            this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
        }
    };
    AddEditUserPageController.prototype._checkRoleChange = function () {
        if (this.isSeniorRecruiter(this.userProfileReset.userDetails.role)) {
            this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
        else if (this.isRecruiter(this.userProfileReset.userDetails.role)) {
            this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
        else if (this.isRecruitingManager(this.userProfileReset.userDetails.role)) {
            if (this.isRecruiter(this.userProfile.userDetails.role) || this.isSeniorRecruiter(this.userProfile.userDetails.role)) {
                if (angular.isDefined(this.userProfileReset.reporteeCount) && (this.userProfileReset.reporteeCount > 0)) {
                    this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
                }
                else if (angular.isDefined(this.userProfile.reporteeCount) && (this.userProfile.reporteeCount === 0)) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
            else if (this.isCompanyAdmin(this.userProfile.userDetails.role)) {
                if (this.userProfile.reporteeCount > 0) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_TO_ADMIN_REPORTEES);
                }
                else {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
        }
        else if (this.isHiringManager(this.userProfileReset.userDetails.role)) {
            if (this.isRecruiter(this.userProfile.userDetails.role) || this.isSeniorRecruiter(this.userProfile.userDetails.role)) {
                if (angular.isDefined(this.userProfileReset.reporteeCount) && (this.userProfileReset.reporteeCount > 0)) {
                    this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
                }
                else if (angular.isDefined(this.userProfile.reporteeCount) && (this.userProfile.reporteeCount === 0)) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
            else if (this.isCompanyAdmin(this.userProfile.userDetails.role)) {
                if (this.userProfile.reporteeCount > 0) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_TO_ADMIN_REPORTEES);
                }
                else {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
        }
        else if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
            if (this.isRecruiter(this.userProfile.userDetails.role) || this.isSeniorRecruiter(this.userProfile.userDetails.role)) {
                if (angular.isDefined(this.userProfileReset.reporteeCount) && (this.userProfileReset.reporteeCount > 0)) {
                    this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
                }
                else if (angular.isDefined(this.userProfile.reporteeCount) && (this.userProfile.reporteeCount === 0)) {
                    this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
                }
            }
            else if (this.isRecruitingManager(this.userProfile.userDetails.role) || this.isHiringManager(this.userProfile.userDetails.role)) {
                this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
            }
        }
        else {
            alert('Something went wrong ! please try again later');
        }
    };
    AddEditUserPageController.prototype._showRoleChangeAlert = function (message) {
        var _this = this;
        bootbox.alert({
            closeButton: false,
            title: '<div class="alert alert-danger"><i class="fa fa-times-circle fa-fw fa-lg"></i><strong>Oh snap!</strong></div>',
            message: message,
            callback: function () {
                _this.userProfile.userDetails.role = angular.copy(_this.userProfileReset.userDetails.role);
                _this.form.userDetailsForm.role.$setPristine();
            }
        });
    };
    AddEditUserPageController.prototype._showRoleChangeConfirmation = function (message) {
        var _this = this;
        bootbox.confirm({
            closeButton: false, title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>", message: message,
            buttons: {
                confirm: {
                    label: 'Yes', className: 'btn-success'
                }, cancel: {
                    label: 'No', className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    if (_this.isCompanyAdmin(_this.userProfileReset.userDetails.role)) {
                        _this.userProfile.userDetails.manager = null;
                        _this._getManagerListWhileDemotingAdmin(_this.userProfile.userDetails.userId);
                        angular.element('#manager').attr({ 'readonly': false, 'disabled': false });
                    }
                    else {
                        _this._getManagersList(_this.userProfile.userDetails.userId, _this.userProfile.userDetails.role.id, _this.userProfile.buId);
                    }
                }
                else {
                    _this.userProfile.userDetails.role = angular.copy(_this.userProfileReset.userDetails.role);
                    _this.form.userDetailsForm.role.$setPristine();
                }
            }
        });
    };
    /**
    * This method will be called when ever Manager is changed from ui
    */
    AddEditUserPageController.prototype.changeManagerObject = function () {
        var _this = this;
        if (this.userProfile.reporteeCount > 0) {
            var changeManagerMessage = this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_REPORTEES;
        }
        else {
            var changeManagerMessage = this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER;
        }
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: changeManagerMessage,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    var managerid = angular.copy(_this.userProfile.userDetails.manager.userId);
                    for (var i = 0; i < _this.managerList.length; i++) {
                        if (managerid === _this.managerList[i].userId) {
                            _this.userProfile.userDetails.manager = angular.copy(_this.managerList[i]);
                            _this.updatedManager = angular.copy(_this.userProfile.userDetails.manager);
                        }
                    }
                }
                else {
                    _this.userProfile.userDetails.manager = angular.copy(_this.userProfileReset.userDetails.manager);
                }
            }
        });
    };
    /**
     * This method is called when changed in CITY OR STATE OR COUNTY OR COUNTRY dropdowns.
     * This method will take care of changes to be made to other attributes when one
     * is changed among above specified one's.
     */
    AddEditUserPageController.prototype.changeAddressObject = function (type, obj) {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        switch (type) {
            case 'city':
                for (var p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].city === obj) {
                        this.userProfile.userDetails.state = this.geoLocationsCopy[p].state;
                        this.userProfile.userDetails.country = this.geoLocationsCopy[p].country;
                        this.userProfile.userDetails.county = this.geoLocationsCopy[p].county;
                        if (angular.isDefined(this.geoLocationsCopy[p].county) && (this.geoLocationsCopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
            case 'state':
                for (var p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].state === obj) {
                        this.userProfile.userDetails.city = this.geoLocationsCopy[p].city;
                        this.userProfile.userDetails.country = this.geoLocationsCopy[p].country;
                        this.userProfile.userDetails.county = this.geoLocationsCopy[p].county;
                        if (angular.isDefined(this.geoLocationsCopy[p].county) && (this.geoLocationsCopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
            case 'country':
                for (var p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].country === obj) {
                        this.userProfile.userDetails.city = this.geoLocationsCopy[p].city;
                        this.userProfile.userDetails.state = this.geoLocationsCopy[p].state;
                        this.userProfile.userDetails.county = this.geoLocationsCopy[p].county;
                        if (angular.isDefined(this.geoLocationsCopy[p].county) && (this.geoLocationsCopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
            case 'county':
                for (var p = 0; p < this.geoLocationsCopy.length; p++) {
                    if (this.geoLocationsCopy[p].county === obj) {
                        this.userProfile.userDetails.city = this.geoLocationsCopy[p].city;
                        this.userProfile.userDetails.country = this.geoLocationsCopy[p].country;
                        this.userProfile.userDetails.state = this.geoLocationsCopy[p].state;
                        this.countryCode = this.geoLocationsCopy[p].countryCode;
                        this._setWorkTelephoneCountryCode();
                        this._setMobileNumberCountryCode();
                    }
                }
                break;
        }
    };
    AddEditUserPageController.prototype.disableCountyFieldIfViewMode = function () {
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
            angular.element('#county').attr({ 'readonly': true, 'disabled': true });
        }
    };
    AddEditUserPageController.prototype.toggleCopyCompanyAddress = function () {
        var _this = this;
        this.copyCompanyAddress = document.getElementById("copyCompanyAddress").checked;
        var companyAddressZipcode;
        if (this.copyCompanyAddress) {
            this.companyService.getCompanyDetails(this.$rootScope.userDetails.company.companyId, function (data) {
                companyAddressZipcode = data.company.zipcode;
                _this.userProfile.userDetails.address1 = data.company.address1;
                _this.userProfile.userDetails.address2 = data.company.address2;
                _this.userProfile.userDetails.zipcode = companyAddressZipcode;
                _this.cancelClicked = false;
                _this._getAddressDetails(companyAddressZipcode, 'copycomanyaddress', function (response) {
                    angular.element('.companyaddresscopyenabled').attr({ 'readonly': true, 'disabled': true });
                });
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else {
            this.copyCompanyAddress = false;
            angular.element('.companyaddresscopyenabled').attr({ 'readonly': false, 'disabled': false });
            if (this.accessMode == this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                this.userProfile.userDetails.address1 = this.userProfileReset.userDetails.address1;
                this.userProfile.userDetails.address2 = this.userProfileReset.userDetails.address2;
                this.userProfile.userDetails.zipcode = this.userProfileReset.userDetails.zipcode;
                this._getAddressDetails(this.userProfile.userDetails.zipcode, 'zipchanged', function (response) {
                    if (angular.isDefined(_this.userProfileReset.userDetails.county) && (_this.userProfileReset.userDetails.county !== null)
                        && (_this.userProfile.userDetails.zipcode === _this.userProfileReset.userDetails.zipcode)) {
                        _this.userProfile.userDetails.county = _this.userProfileReset.userDetails.county;
                        // this.$scope.safeApply();
                    }
                });
            }
            else {
                this.userProfile.userDetails.address1 = this.userProfileReset.userDetails.address1;
                this.userProfile.userDetails.address2 = this.userProfileReset.userDetails.address2;
                this.userProfile.userDetails.zipcode = this.userProfileReset.userDetails.zipcode;
                this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'zipchanged', function (response) {
                    if (angular.isDefined(_this.userProfileReset.userDetails.county) && (_this.userProfileReset.userDetails.county !== null)
                        && (_this.userProfile.userDetails.zipcode === _this.userProfileReset.userDetails.zipcode)) {
                        _this.userProfile.userDetails.county = _this.userProfileReset.userDetails.county;
                        // this.$scope.safeApply();
                    }
                });
            }
        }
    };
    AddEditUserPageController.prototype.onUserBelongsToBUChanged = function () {
        var _this = this;
        this.isUserBelongsToBUChanged = true;
        var isBelongsToBUChangeValid = (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) ||
            ((this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) && ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)));
        if (isBelongsToBUChangeValid) {
            if (this.userProfile.reporteeCount > 0) {
                bootbox.confirm({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                    message: "All the users and employees in the hierarchy reporting to the user will also have their 'Belongs to BU' changed.<br> Do you wish to continue?",
                    className: "zIndex1060",
                    backdrop: true,
                    onEscape: false,
                    buttons: {
                        confirm: {
                            label: 'Yes',
                            className: 'btn-info'
                        },
                        cancel: {
                            label: 'Cancel',
                            className: 'btn-danger'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            _this._setBuName();
                            _this._getManagersList(_this.userProfile.userDetails.userId, _this.userProfile.userDetails.role.id, _this.userProfile.buId);
                        }
                        else {
                            _this.userProfile.buId = _this.userProfileReset.buId;
                        }
                    }
                });
            }
            else {
                this._setBuName();
                this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
            }
        }
    };
    AddEditUserPageController.prototype.getDepartments = function (searchTerm) {
        var searchObject = {
            'searchText': searchTerm,
            'companyId': this.companyId
        };
        return this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then(function (data) {
            return data;
        });
    };
    AddEditUserPageController.prototype.departmentTypeAheadDepartmentAdded = function (tag) {
        this.userProfile.departmentName = tag.name;
        if (!_.isUndefined(tag.id)) {
            this.userProfile.departmentId = tag.id;
        }
    };
    AddEditUserPageController.prototype.departmentTypeAheadDepartmentRemoved = function (tag) {
        this.userProfile.departmentId = null;
        this.userProfile.departmentName = null;
    };
    AddEditUserPageController.prototype.onClientOrBuSelection = function (clientOrBu) {
        var _this = this;
        if (!clientOrBu.enabled) {
            this.userService.checkIfUserHasRequisitionsInClientOrBu(this.companyId, this.userProfile.userDetails.userId, clientOrBu.id, function (data) {
                if (data) {
                    clientOrBu.enabled = !clientOrBu.enabled;
                    var clientOrBULabel = _this.isStaffingCompany ? "Client" : "BU";
                    _this._showClientOrBuCannotBeRemovedMessage(clientOrBULabel);
                }
                else if (!clientOrBu.enabled && clientOrBu.subordinatesBelongToBu) {
                    clientOrBu.enabled = !clientOrBu.enabled;
                    _this._showClientOrBuUncheckableWarning(clientOrBu);
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    AddEditUserPageController.prototype.onClientsBuSelection = function (bu) {
        var _this = this;
        if (!bu.enabled) {
            this.userService.checkIfUserHasRequisitionsInClientOrBu(this.companyId, this.userProfile.userDetails.userId, bu.buId, function (data) {
                if (data) {
                    bu.enabled = !bu.enabled;
                    _this._showClientOrBuCannotBeRemovedMessage("Client's BU");
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    AddEditUserPageController.prototype._showClientOrBuCannotBeRemovedMessage = function (clientOrBULabel) {
        var title = clientOrBULabel + " cannot be removed";
        var message = "This " + clientOrBULabel + " cannot be removed as there are requisitions under this user that are associated with this " + clientOrBULabel + ".";
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>" + title + "</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    };
    AddEditUserPageController.prototype._showClientOrBuUncheckableWarning = function (clientOrBu) {
        var _this = this;
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-medium',
            component: 'addEditUserActionsModal',
            resolve: {
                userId: function () {
                    return _this.userProfile.userDetails.userId;
                },
                buId: function () {
                    return clientOrBu.id;
                },
                isCorporate: function () {
                    return _this.isCorporateFlag;
                }
            }
        });
    };
    //utilities
    AddEditUserPageController.prototype.handleLongName = function (longName, limitToMax) {
        return this.utilityService.handleLongName(longName, limitToMax);
    };
    AddEditUserPageController.prototype.getFullName = function (firstName, lastName) {
        return this.utilityService.getFullName(firstName, lastName);
    };
    AddEditUserPageController.prototype.isLoggedInUser = function (userDetails) {
        // return this.utilityService.isLoggedInUser(userDetails);
        return angular.equals(userDetails.userId, this.$rootScope.userDetails.id);
    };
    AddEditUserPageController.prototype.isSuperUser = function (role) {
        return this.userRoleService.isSuperUser(role);
    };
    AddEditUserPageController.prototype.isFourDotFiveAdmin = function (role) {
        return this.userRoleService.isFourDotFiveAdmin(role);
    };
    AddEditUserPageController.prototype.isCompanyAdmin = function (role) {
        // return this.userRoleService.isCompanyAdmin(role);
        return angular.equals(role.id, this.MESSAGECONSTANTS.ROLEIDS.STAFFING_ADMIN) || angular.equals(role.id, this.MESSAGECONSTANTS.ROLEIDS.CORPORATE_ADMIN);
    };
    AddEditUserPageController.prototype.isRecruitingManager = function (role) {
        return this.userRoleService.isRecruitingManager(role);
    };
    AddEditUserPageController.prototype.isHiringManager = function (role) {
        return this.userRoleService.isHiringManager(role);
    };
    AddEditUserPageController.prototype.isSeniorRecruiter = function (role) {
        return this.userRoleService.isSeniorRecruiter(role);
    };
    AddEditUserPageController.prototype.isRecruiter = function (role) {
        return this.userRoleService.isRecruiter(role);
    };
    /**
     * Forward Recipients fromDate and toDate validations are done in this method
     */
    AddEditUserPageController.prototype.checkDateValidation = function () {
        var enter = !angular.equals(this.userProfile.userForwardRecipientDetails, null) &&
            angular.isDefined(this.userProfile.userForwardRecipientDetails.forwardRecipient) &&
            !angular.equals(this.userProfile.userForwardRecipientDetails.forwardRecipient, null) &&
            angular.isDefined(this.userProfile.userForwardRecipientDetails.fromDate) &&
            !angular.equals(this.userProfile.userForwardRecipientDetails.fromDate, null) &&
            angular.isDefined(this.userProfile.userForwardRecipientDetails.toDate) &&
            !angular.equals(this.userProfile.userForwardRecipientDetails.toDate, null) &&
            !angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate).toString(), 'Invalid Date') &&
            !angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate).toString(), 'Invalid Date');
        if (enter) {
            var keys = Object.keys(this.userProfile.userForwardRecipientDetails.forwardRecipient);
            var last = keys.slice(-2)[0];
            //delete this.userProfile.userForwardRecipientDetails.forwardRecipient[last];
            var datevalid = new Date(this.userProfile.userForwardRecipientDetails.fromDate).getTime() <= new Date(this.userProfile.userForwardRecipientDetails.toDate).getTime();
            if (!datevalid) {
                this.form.userForwardRecipientsform.$setValidity('date', false);
                this.form.userForwardRecipientsform.fromDate.$setValidity('date', false);
                this.form.userForwardRecipientsform.toDate.$setValidity('date', false);
            }
            else {
                this.form.userForwardRecipientsform.$setValidity('date', true);
                this.form.userForwardRecipientsform.fromDate.$setValidity('date', true);
                this.form.userForwardRecipientsform.toDate.$setValidity('date', true);
                var timevalid = angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime(), NaN) ||
                    angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime(), NaN) ||
                    (new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime() > new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime());
                if (!timevalid) {
                    if (!angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime(), NaN) &&
                        !angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime(), NaN)) {
                        this.form.userForwardRecipientsform.$setValidity('time', false);
                        this.form.userForwardRecipientsform.fromTime.$setValidity('time', false);
                        this.form.userForwardRecipientsform.toTime.$setValidity('time', false);
                    }
                }
                else {
                    this.form.userForwardRecipientsform.$setValidity('time', true);
                    this.form.userForwardRecipientsform.fromTime.$setValidity('time', true);
                    this.form.userForwardRecipientsform.toTime.$setValidity('time', true);
                }
            }
        }
        else {
            if (this.dateTimeCount <= 1) {
                var date = new Date();
                var time = date.toTimeString().split(' ')[0].split(':');
                this.userProfile.userForwardRecipientDetails.fromTime = time[0] + ':' + time[1] + ':' + time[2];
                this.userProfile.userForwardRecipientDetails.toTime = time[0] + ':' + time[1] + ':' + time[2];
                this.dateTimeCount++;
            }
            else {
                this.dateTimeCount++;
                var timevalid = angular.equals(new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime(), NaN) ||
                    angular.equals(new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime(), NaN) ||
                    (new Date(this.userProfile.userForwardRecipientDetails.toDate + ' ' + this.userProfile.userForwardRecipientDetails.toTime).getTime() > new Date(this.userProfile.userForwardRecipientDetails.fromDate + ' ' + this.userProfile.userForwardRecipientDetails.fromTime).getTime());
                this.form.userForwardRecipientsform.fromTime.$setValidity('time', true);
                this.form.userForwardRecipientsform.toTime.$setValidity('time', true);
            }
        }
    };
    AddEditUserPageController.prototype.single = function () {
    };
    //Handle navigating away when data is unsaved
    AddEditUserPageController.prototype.uiCanExit = function (transitions) {
        var _this = this;
        var toState = transitions.to().name;
        var toParams = transitions.params();
        var confirmationAtStep = this._getCurrentStep();
        if (angular.copy(this.showConfirmationPopup)) {
            this.showConfirmationPopup = false;
        }
        else if (this.accessMode !== this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
            if ((confirmationAtStep === 1) && this._hasStepDataChanged(confirmationAtStep)) {
                this.showConfirmationPopup = true;
            }
            else if ((confirmationAtStep === 2) && this._hasStepDataChanged(confirmationAtStep)) {
                this.showConfirmationPopup = true;
            }
        }
        if (this.showConfirmationPopup && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        // Handling data change when clicked on Switch company 
                        if (_this.$rootScope.switchClicked) {
                            // this.companyService.showAllCompanies();
                            _this.uibModalService.showAllCompanies();
                            _this.$rootScope.switchClicked = false;
                        }
                        else {
                            _this.clearData();
                            _this.StorageService.remove('wizardoperations');
                            _this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        _this.showConfirmationPopup = false;
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this._hasStepDataChanged(confirmationAtStep)) {
                transitions.abort();
                this.$timeout(function () {
                    // this.companyService.showAllCompanies();
                    _this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    };
    AddEditUserPageController.prototype._handleBrowserEvents = function () {
        var _this = this;
        //Handle Browser back/forward change
        var unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', function (event, toState, toParams, fromState, fromParams) {
            _this.isLocationChange = _this.isLocationChangeInitial;
            _this.isLocationChangeInitial = true;
        });
    };
    return AddEditUserPageController;
}());
export { AddEditUserPageController };
AddEditUserPageController.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$filter', '$uibModal', '$transitions', 'StorageService', 'utilityService', 'userRoleService', 'employeeService', 'userService', 'companyService', 'USERMANAGEMENTCONSTANTS', 'MESSAGECONSTANTS', 'alertsAndNotificationsService', 'uibModalService'];
// import * as TEMPLATE from './add-edit-user-page.html';
import * as TEMPLATE from 'raw-loader!./add-edit-user-page.html';
export var AddEditUserPageComponent = {
    selector: 'addEditUserPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/addEditUser/add-edit-user-page.html',
        controller: AddEditUserPageController
    }
};
//# sourceMappingURL=add-edit-user-page.component.js.map